import { render } from "./SampleAssets.vue?vue&type=template&id=3c6fd703"
import script from "./SampleAssets.vue?vue&type=script&lang=js"
export * from "./SampleAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__